import { render } from "./UsersReport.vue?vue&type=template&id=494aba90&ts=true"
import script from "./UsersReport.vue?vue&type=script&lang=ts"
export * from "./UsersReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__